var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 3.5C8.1908 3.5457 9.92478 2.96771 11.3167 1.86667C11.4033 1.80167 11.5064 1.76209 11.6143 1.75236C11.7222 1.74263 11.8306 1.76314 11.9275 1.81158C12.0244 1.86003 12.1059 1.9345 12.1629 2.02666C12.2198 2.11881 12.25 2.225 12.25 2.33333V9.33333C12.25 9.44167 12.2198 9.54786 12.1629 9.64001C12.1059 9.73216 12.0244 9.80664 11.9275 9.85508C11.8306 9.90353 11.7222 9.92404 11.6143 9.91431C11.5064 9.90458 11.4033 9.865 11.3167 9.8C9.92478 8.69896 8.1908 8.12097 6.41667 8.16667H2.91667C2.60725 8.16667 2.3105 8.04375 2.09171 7.82496C1.87292 7.60617 1.75 7.30942 1.75 7V4.66667C1.75 4.35725 1.87292 4.0605 2.09171 3.84171C2.3105 3.62292 2.60725 3.5 2.91667 3.5H6.41667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.16602C3.5 9.68061 3.99124 11.1543 4.9 12.366C5.08565 12.6136 5.36203 12.7772 5.66834 12.821C5.97465 12.8647 6.2858 12.785 6.53333 12.5993C6.78087 12.4137 6.94452 12.1373 6.98827 11.831C7.03203 11.5247 6.95232 11.2136 6.76667 10.966C6.16083 10.1582 5.83333 9.17574 5.83333 8.16602",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 3.5V8.16667",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.ff928e135409b6aa4fbd9afdaf6bac81.svg";
export { ForwardRef as ReactComponent };